import React, { Component } from 'react';
import { getHexColor, COLOR_TRANSPARENT } from '../../utils/color';

import './color-display.less';

export default class ColorDisplay extends Component {
    render() {
        const { value, text } = this.props;
        const hex = getHexColor( value );

        return (
            <span className="color-display">
                <span
                    className="preview"
                    style={ { backgroundColor: hex ? hex : COLOR_TRANSPARENT } }
                />
                {
                    text && (
                        <span className="text">{ text }</span>
                    )
                }
            </span>
        );
    }
}
